import { isOfType } from 'common/helpers'
import type { MarkerId, Nullable, ProjectId } from 'common/types'

import type { CubeBriefInfo } from './cubes'
import type { Field } from './projectRefBooks'
import type { CompanyId, CubeId, FieldId, GisId, InclinometryId, SurveyId } from './types'

export type ProjectWellType = {
  id: string
  inclinometry: InclinometryId[]
  gis: GisId[]
  markers: MarkerId[]
}

export type ProjectHorizonType = {
  id: string
  cubes: CubeId[]
  surveys: SurveyId[]
}

export type Project = {
  id: ProjectId
  fields: Field[]
  wells: ProjectWellType[]
  cubes: CubeBriefInfo[]
  faults: string[]
  horizons: ProjectHorizonType[]
  surveys2ds: string[]
  maps: string[]
}

export type ProjectState = 'Public' | 'Private'

const ProjectTypeArr = ['Monitoring', 'PZ_OPZ', 'PTD'] as const
export type ProjectType = (typeof ProjectTypeArr)[number]
export const isProjectType = isOfType(ProjectTypeArr)

export type ProjectDetail = {
  id: ProjectId
  name: string
  type?: Nullable<ProjectType>
  year: number
  state?: Nullable<ProjectState>
  companyId?: CompanyId
  createdAt?: string
  changedAt?: string
  fieldId?: Nullable<FieldId>
  createdBy?: Nullable<string>
  organizationName?: string
  fieldName?: string
  status?: string
  companyName?: string
  tags?: string[]
  size: string
}

export type ProjectTableView = ProjectDetail & {
  icons: boolean
}

export type ProjectStateUpdate = {
  projectId: ProjectId
  newState: ProjectState
}
